{
  "app.name": "Email Butler",
  "app.tagline": "Je mailboxen, onder controle.",
  "nav.today": "Vandaag",
  "nav.attention": "Vraagt aandacht",
  "nav.decisions": "Beslissingen",
  "nav.allMail": "Alle e-mail",
  "nav.people": "Mensen",
  "nav.money": "Geld",
  "nav.family": "Gezin & school",
  "nav.documents": "Documenten",
  "nav.subscriptions": "Abonnementen",
  "nav.waiting": "Wacht op",
  "nav.search": "Zoeken",
  "nav.butler": "Butler",
  "nav.rescue": "Rescue",
  "nav.mailboxes": "Mailboxen",
  "nav.vault": "Kluis",
  "nav.activity": "Activiteit",
  "nav.settings": "Instellingen",
  "common.open": "Openen",
  "common.cancel": "Annuleren",
  "common.save": "Opslaan",
  "common.close": "Sluiten",
  "common.retry": "Opnieuw proberen",
  "common.undo": "Ongedaan maken",
  "common.approve": "Goedkeuren",
  "common.reject": "Afwijzen",
  "common.remind": "Herinner me",
  "common.handled": "Afgehandeld",
  "common.keep": "Behouden",
  "common.loading": "Laden…",
  "common.language": "Taal",
  "common.signOut": "Afmelden",
  "today.greeting.morning": "Goedemorgen",
  "today.greeting.afternoon": "Goedemiddag",
  "today.greeting.evening": "Goedenavond",
  "today.attentionCount": {
    "zero": "Er vraagt niets om je aandacht",
    "one": "{count} ding vraagt om je aandacht",
    "other": "{count} dingen vragen om je aandacht"
  },
  "today.deadlinesThisWeek": {
    "zero": "Geen deadlines deze week",
    "one": "{count} deadline deze week",
    "other": "{count} deadlines deze week"
  },
  "today.peopleWaiting": {
    "zero": "Niemand wacht op je",
    "one": "{count} persoon wacht op je",
    "other": "{count} mensen wachten op je"
  },
  "today.scope.all": "Alle mailboxen",
  "today.scope.label": "Toon één mailbox",
  "mail.reply.title": "Beantwoorden",
  "mail.reply.placeholder": "Je antwoord, in je eigen woorden…",
  "mail.reply.send": "Antwoord versturen",
  "mail.reply.sendAll": "Allen beantwoorden",
  "mail.reply.sent": "Verstuurd, en opgeborgen in je mailbox.",
  "mail.reply.failed": "Niet verstuurd. Er heeft niets je mailbox verlaten — probeer opnieuw.",
  "today.section.appointments": "Waar je verwacht wordt",
  "today.appointment.untitled": "(naamloze afspraak)",
  "today.appointment.unanswered": "nog niet beantwoord",
  "mail.title": "Alle e-mail",
  "mail.empty": "Nog niets. Mail verschijnt zodra hij synchroniseert.",
  "mail.noSubject": "(geen onderwerp)",
  "mail.backToList": "Terug naar de lijst",
  "mail.openMessage": "Dit bericht lezen",
  "mail.error.title": "Je mail kon niet geladen worden",
  "mail.remoteBlocked": "{count} externe bronnen zijn niet geladen, dus de afzender weet niet dat je dit opende.",
  "today.progress.title": "Butler is aan het werk",
  "today.progress.classifying": "Je mail leren kennen: {done} van {total} berichten begrepen",
  "today.progress.firstPass": "De eerste ronde loopt. Elk kwartier landt een nieuwe batch.",
  "today.progress.lastPass": "Laatste batch: {count} berichten om {time}. De volgende landt binnen een kwartier.",
  "today.progress.rescue": "Rescue-analyse: {done} van {total} delen over {messages} berichten",
  "today.butlerHandled": {
    "zero": "Butler heeft vandaag verder niets afgehandeld",
    "one": "Butler heeft vandaag {count} ander bericht afgehandeld",
    "other": "Butler heeft vandaag {count} andere berichten afgehandeld"
  },
  "today.empty.title": "Je bent helemaal bij",
  "today.empty.body": "Butler houdt je mailboxen in de gaten. Je ziet hier iets zodra het je echt nodig heeft.",
  "today.reviewActivity": "Activiteit bekijken",
  "mailbox.state.connected": "Verbonden",
  "mailbox.state.inventory": "Inventarisatie bezig",
  "mailbox.state.backingUp": "Veiligheidskopie wordt gemaakt",
  "mailbox.state.snapshotVerified": "Kopie geverifieerd",
  "mailbox.state.rescuing": "Opruimen bezig",
  "mailbox.state.active": "Bijgewerkt",
  "mailbox.state.degraded": "Vraagt aandacht",
  "mailbox.state.reauthRequired": "Opnieuw verbinden nodig",
  "mailbox.state.paused": "Gepauzeerd",
  "mailbox.state.disconnected": "Niet verbonden",
  "mailbox.messageCount": {
    "one": "{count} bericht",
    "other": "{count} berichten"
  },
  "vault.title": "Kluis",
  "vault.explainer": "Voordat Butler iets opruimt, maakt hij eerst een geverifieerde kopie die hij kan terugzetten.",
  "vault.protectedBy": "Beschermd door kopie van: {date}",
  "vault.status.verified": "Geverifieerd",
  "vault.status.pending": "Wacht op start",
  "vault.status.copying": "Kopiëren",
  "vault.status.verifying": "Verifiëren",
  "vault.status.failed": "Mislukt",
  "onboarding.backup.title": "Bescherm deze mailbox voordat Butler gaat opruimen",
  "onboarding.backup.full": "Volledige veiligheidskopie — aanbevolen",
  "onboarding.backup.metadataOnly": "Alleen metadata kopiëren",
  "onboarding.backup.skip": "Doorgaan zonder kopie",
  "onboarding.backup.skipWarning": "Zonder kopie kan Butler berichten niet terugzetten als er iets misgaat. Dit geldt met terugwerkende kracht voor alles wat er gebeurt voordat er een kopie bestaat.",
  "auth.signIn": "Aanmelden",
  "auth.signUp": "Account aanmaken",
  "auth.email": "E-mailadres",
  "auth.password": "Wachtwoord",
  "auth.mfaCode": "Verificatiecode",
  "auth.forgotPassword": "Wachtwoord vergeten?",
  "error.VALIDATION_FAILED": "Een paar ingevulde gegevens hebben aandacht nodig.",
  "error.MALFORMED_REQUEST": "Dat verzoek kon niet worden verwerkt.",
  "error.UNSUPPORTED_MEDIA_TYPE": "Dit bestandstype wordt niet ondersteund.",
  "error.IDEMPOTENCY_KEY_REUSED": "Deze actie is al verstuurd.",
  "error.AUTHENTICATION_REQUIRED": "Meld je aan om verder te gaan.",
  "error.AUTHENTICATION_FAILED": "Deze aanmeldgegevens werkten niet.",
  "error.MFA_REQUIRED": "Voer je verificatiecode in om verder te gaan.",
  "error.SESSION_EXPIRED": "Je sessie is verlopen. Meld je opnieuw aan.",
  "error.PERMISSION_DENIED": "Je hebt geen toestemming om dit te doen.",
  "error.TENANT_MISMATCH": "Dit item hoort bij een andere werkruimte.",
  "error.NOT_FOUND": "We konden dit niet vinden.",
  "error.CONFLICT": "Dit is gewijzigd terwijl je ermee bezig was. Herlaad en probeer opnieuw.",
  "error.PRECONDITION_FAILED": "Er moet eerst iets anders gebeuren.",
  "error.POLICY_FORBIDS_ACTION": "Het beleid van je werkruimte staat dit niet toe.",
  "error.BACKUP_REQUIRED": "Voor deze actie is een geverifieerde kopie vereist.",
  "error.CONFIRMATION_REQUIRED": "Dit heeft je uitdrukkelijke bevestiging nodig.",
  "error.FEATURE_DISABLED": "Deze functie staat uit.",
  "error.RATE_LIMITED": "Dat zijn veel verzoeken. Wacht even.",
  "error.PROVIDER_UNAVAILABLE": "Je mailprovider reageert nu niet. Er is geen e-mail verloren gegaan.",
  "error.AI_UNAVAILABLE": "De analyse van Butler is gepauzeerd. Je e-mail wordt gewoon gesynchroniseerd en er is niets verwijderd.",
  "error.INTERNAL_ERROR": "Er ging iets mis aan onze kant. Je e-mail is veilig.",
  "error.SERVICE_UNAVAILABLE": "Email Butler is tijdelijk niet beschikbaar.",
  "error.reference": "Referentie: {requestId}",
  "auth.signIn.title": "Welkom terug",
  "auth.signIn.subtitle": "Meld je aan bij je werkruimtes.",
  "auth.signIn.submit": "Aanmelden",
  "auth.signIn.noAccount": "Nog geen account?",
  "auth.register.title": "Maak je account",
  "auth.register.subtitle": "Eén account, al je mailboxen.",
  "auth.register.submit": "Account aanmaken",
  "auth.register.hasAccount": "Heb je al een account?",
  "auth.register.sent.title": "Controleer je e-mail",
  "auth.register.sent.body": "Als dit adres bruikbaar is, hebben we er een verificatielink naartoe gestuurd.",
  "auth.register.passwordHint": "Minimaal {count} tekens. Lengte telt zwaarder dan speciale tekens.",
  "auth.registration.invitationOnly": "Accounts worden momenteel door een beheerder aangemaakt.",
  "auth.registration.closed.title": "Registratie is alleen op uitnodiging",
  "auth.registration.closed.body": "Publieke registratie staat uit zolang Email Butler wordt getest. Vraag de beheerder om je account aan te maken.",
  "auth.displayName": "Je naam",
  "auth.newPassword": "Nieuw wachtwoord",
  "auth.currentPassword": "Huidig wachtwoord",
  "auth.verify.title": "Je e-mailadres wordt geverifieerd",
  "auth.verify.success": "Je e-mailadres is geverifieerd. Je kunt je nu aanmelden.",
  "auth.verify.failed": "Deze verificatielink is ongeldig of verlopen.",
  "auth.forgot.title": "Wachtwoord opnieuw instellen",
  "auth.forgot.subtitle": "We sturen een link als er een account bij dit adres hoort.",
  "auth.forgot.submit": "Stuur link",
  "auth.forgot.sent": "Als er een account bij dit adres hoort, is er een link onderweg.",
  "auth.reset.title": "Kies een nieuw wachtwoord",
  "auth.reset.submit": "Wachtwoord instellen",
  "auth.reset.success": "Je wachtwoord is bijgewerkt. Meld je er nu mee aan.",
  "auth.mfa.title": "Nog één stap",
  "auth.mfa.subtitle": "Voer de code uit je authenticator-app in, of een herstelcode.",
  "auth.mfa.submit": "Verifiëren",
  "auth.backToSignIn": "Terug naar aanmelden",
  "auth.unreachable.title": "We kunnen Email Butler niet bereiken",
  "auth.unreachable.body": "Je e-mail is onaangeroerd. Dit is een verbindingsprobleem, geen afmelding.",
  "security.title": "Beveiliging",
  "security.mfa.title": "Tweestapsverificatie",
  "security.mfa.enabled": "Ingeschakeld",
  "security.mfa.disabled": "Niet ingeschakeld",
  "security.mfa.explainer": "Een tweede factor beschermt elke mailbox die je hebt gekoppeld. We raden dit sterk aan.",
  "security.mfa.enable": "Tweestapsverificatie inschakelen",
  "security.mfa.disable": "Tweestapsverificatie uitschakelen",
  "security.mfa.scan": "Scan dit in je authenticator-app, of voer de sleutel handmatig in.",
  "security.mfa.confirm": "Code bevestigen",
  "security.mfa.recoveryTitle": "Bewaar je herstelcodes",
  "security.mfa.recoveryBody": "Elke code werkt één keer. Bewaar ze op een veilige plek — het is de enige weg terug als je je apparaat kwijtraakt. We kunnen ze niet opnieuw tonen.",
  "security.mfa.recoveryRemaining": {
    "one": "Nog {count} herstelcode",
    "other": "Nog {count} herstelcodes"
  },
  "security.sessions.title": "Aangemelde apparaten",
  "security.sessions.current": "Dit apparaat",
  "security.sessions.lastSeen": "Laatst gebruikt {when}",
  "security.sessions.revoke": "Afmelden",
  "security.password.title": "Wachtwoord",
  "security.password.change": "Wachtwoord wijzigen",
  "security.password.changed": "Je wachtwoord is bijgewerkt. Andere apparaten zijn afgemeld.",
  "workspace.switch": "Werkruimte",
  "workspace.none.title": "Nog geen werkruimte",
  "workspace.none.body": "Je bent aangemeld maar hoort nog bij geen werkruimte. Vraag een eigenaar om je uit te nodigen, of maak er zelf een.",
  "command.open": "Zoeken en opdrachten",
  "command.placeholder": "Zoek of spring naar…",
  "command.empty": "Daar past niets bij.",
  "command.section.navigate": "Ga naar",
  "command.section.actions": "Acties",
  "command.action.toggleTheme": "Wissel tussen licht en donker",
  "command.action.signOut": "Afmelden",
  "workspace.create.title": "Maak je werkruimte",
  "workspace.create.body": "Een werkruimte bevat je mailboxen, je regels en je geschiedenis. Je kunt er later mensen voor uitnodigen.",
  "workspace.create.name": "Naam van de werkruimte",
  "workspace.create.slug": "Adres",
  "workspace.create.slugHint": "Kleine letters, cijfers en koppeltekens. Dit verschijnt in links.",
  "workspace.create.submit": "Werkruimte aanmaken",
  "passkey.title": "Passkeys",
  "passkey.explainer": "Met een passkey meld je je aan met je apparaat — gezicht, vingerafdruk of pincode. Phishing werkt er niet op: je browser geeft hem niet aan een nagemaakte site.",
  "passkey.add": "Passkey toevoegen",
  "passkey.signIn": "Aanmelden met een passkey",
  "passkey.none": "Nog geen passkeys.",
  "passkey.remove": "Verwijderen",
  "passkey.added": "Toegevoegd {when}",
  "passkey.lastUsed": "Laatst gebruikt {when}",
  "passkey.neverUsed": "Nooit gebruikt",
  "passkey.synced": "Gesynchroniseerd tussen je apparaten",
  "passkey.singleDevice": "Alleen dit apparaat",
  "passkey.unsupported": "Deze browser ondersteunt geen passkeys.",
  "passkey.cancelled": "Dat is geannuleerd. Er is niets gewijzigd.",
  "proposal.title.archive_bulk_sender": {
    "one": "{count} bericht van {sender} archiveren",
    "other": "{count} berichten van {sender} archiveren"
  },
  "proposal.title.archive_notifications": {
    "one": "{count} oude melding van {sender} archiveren",
    "other": "{count} oude meldingen van {sender} archiveren"
  },
  "proposal.title.mark_historical_read": {
    "one": "{count} oud ongelezen bericht van {sender} als gelezen markeren",
    "other": "{count} oude ongelezen berichten van {sender} als gelezen markeren"
  },
  "proposal.title.reorganize_category": {
    "one": "{count} bericht uit {category} verplaatsen naar {folder}",
    "other": "{count} berichten uit {category} verplaatsen naar {folder}"
  },
  "proposal.title.keep_transactions": "{subject} nooit voorstellen om op te ruimen",
  "proposal.undo.archive_bulk_sender": "Ongedaan maken zet elk bericht terug in de map waar het stond. Er wordt niets verwijderd.",
  "proposal.undo.archive_notifications": "Ongedaan maken zet elk bericht terug in de map waar het stond. Er wordt niets verwijderd.",
  "proposal.undo.mark_historical_read": "Ongedaan maken markeert ze weer als ongelezen. Er wordt niets verplaatst of verwijderd.",
  "proposal.undo.reorganize_category": "Ongedaan maken zet elk bericht terug waar het stond.",
  "proposal.undo.keep_transactions": "Er verandert niets. Verwijder de uitzondering om dit weer voorgesteld te krijgen.",
  "proposal.safety.safe": "Veilig",
  "proposal.safety.probably_safe": "Waarschijnlijk veilig",
  "proposal.safety.ask": "Even bekijken",
  "proposal.protectedBy": "Beschermd door de back-up van {date}",
  "proposal.notCovered": {
    "one": "{count} bericht zit nog niet in de back-up",
    "other": "{count} berichten zitten nog niet in de back-up"
  },
  "proposal.examplesHeading": "Bijvoorbeeld",
  "proposal.review.approve_all": {
    "one": "{proposals} voorstel goedkeuren, voor {messages} berichten",
    "other": "Alle {proposals} voorstellen goedkeuren, voor {messages} berichten"
  },
  "proposal.review.too_many_to_approve": "Dat zijn {messages} berichten in {proposals} voorstellen. Keur ze goed in groepen van maximaal {limit}.",
  "proposal.review.decided": {
    "one": "{count} voorstel goedgekeurd",
    "other": "{count} voorstellen goedgekeurd"
  },
  "proposal.review.empty": "Er wacht niets op je.",
  "proposal.exclusion.heading": "Nooit opruimen",
  "proposal.exclusion.added": "{value} wordt niet meer voorgesteld om op te ruimen.",
  "proposal.exclusion.removed": "{value} kan weer worden voorgesteld om op te ruimen.",
  "today.headline.clear": {
    "zero": "Er is niets voor je",
    "one": "Er is niets voor je. Butler heeft {count} bericht opgeruimd",
    "other": "Er is niets voor je. Butler heeft {count} berichten opgeruimd"
  },
  "today.headline.attention": {
    "one": "{count} bericht heeft je nodig",
    "other": "{count} berichten hebben je nodig"
  },
  "today.headline.deadlines": {
    "one": "{count} deadline komt eraan",
    "other": "{count} deadlines komen eraan"
  },
  "today.headline.overdue": {
    "one": "{count} ding is te laat",
    "other": "{count} dingen zijn te laat"
  },
  "today.headline.waiting": {
    "one": "{count} persoon wacht op je",
    "other": "{count} mensen wachten op je"
  },
  "today.headline.needsFixing": {
    "one": "{count} ding moet opgelost worden voordat Butler kan werken",
    "other": "{count} dingen moeten opgelost worden voordat Butler kan werken"
  },
  "today.section.attention": "Vraagt je aandacht",
  "today.section.deadlines": "Deadlines",
  "today.section.waitingOnYou": "Wacht op jou",
  "today.section.waitingOnOthers": "Jij wacht op",
  "today.section.handled": "Butler heeft gedaan",
  "today.section.health": "Je mailboxen",
  "today.section.vault": "Safety Vault",
  "today.deadline.due": {
    "one": "Over {count} dag",
    "other": "Over {count} dagen"
  },
  "today.deadline.dueToday": "Vandaag",
  "today.deadline.overdue": {
    "one": "{count} dag te laat",
    "other": "{count} dagen te laat"
  },
  "today.waiting.since": {
    "one": "Wacht {count} dag",
    "other": "Wacht {count} dagen"
  },
  "today.handled.filed": {
    "zero": "Niets opgeruimd",
    "one": "{count} bericht opgeruimd",
    "other": "{count} berichten opgeruimd"
  },
  "today.handled.proposals": {
    "one": "{count} opruimactie uitgevoerd",
    "other": "{count} opruimacties uitgevoerd"
  },
  "today.handled.unsubscribes": {
    "one": "{count} afmelding verstuurd",
    "other": "{count} afmeldingen verstuurd"
  },
  "today.handled.undoable": {
    "zero": "Er valt niets meer ongedaan te maken",
    "one": "{count} hiervan kun je nog ongedaan maken",
    "other": "{count} hiervan kun je nog ongedaan maken"
  },
  "today.health.ok": "Synchroniseert normaal",
  "today.health.stale": "{mailbox} heeft al {hours} uur niet gesynchroniseerd",
  "today.health.neverSynced": "{mailbox} heeft nog nooit gesynchroniseerd",
  "today.health.disconnected": "{mailbox} is niet verbonden",
  "today.health.degraded": "{mailbox} heeft problemen",
  "today.health.paused": "{mailbox} staat op pauze",
  "today.health.reauthRequired": "{mailbox} vraagt je opnieuw in te loggen",
  "today.vault.ok": "Geback-upt en geverifieerd",
  "today.vault.none": "{mailbox} heeft nog geen geverifieerde back-up. Butler ruimt niets op zolang die er niet is.",
  "today.vault.ageing": "De back-up van {mailbox} is {days} dagen oud",
  "today.vault.stale": "De back-up van {mailbox} is {days} dagen oud en moet vernieuwd worden",
  "today.vault.verified": "Geverifieerd op {date}",
  "today.error.title": "Today kon niet geladen worden",
  "today.error.body": "In plaats van een rustig scherm waar we niet achter staan, hier is het probleem.",
  "today.retry": "Opnieuw proberen",
  "decision.queue.title": "Wacht op jou",
  "decision.queue.empty": "Butler heeft niets te vragen.",
  "decision.queue.counts": "{high} met hoog risico, {medium} gemiddeld, {low} laag",
  "decision.risk.low": "Laag risico",
  "decision.risk.medium": "Even bekijken",
  "decision.risk.high": "Hoog risico",
  "decision.autoApproved": "Butler heeft dit zelf gedaan",
  "decision.reversible": "Kan ongedaan gemaakt worden",
  "decision.irreversible": "Kan niet ongedaan gemaakt worden",
  "decision.preview.showing": {
    "one": "{count} van {total} getoond",
    "other": "{count} van {total} getoond"
  },
  "decision.preview.showingAll": {
    "one": "Alle {total}",
    "other": "Alle {total}"
  },
  "decision.approve": "Ja, doe maar",
  "decision.reject": "Nee",
  "decision.approveAll": "Deze goedkeuren",
  "decision.rejectAll": "Nu even niet",
  "decision.highRiskAlone": "Beslissingen met hoog risico beantwoord je afzonderlijk.",
  "decision.why.title": "Waarom niet?",
  "decision.why.never_again": "Stel dit nooit meer voor",
  "decision.why.not_now": "Nu even niet",
  "decision.why.wrong_subject": "Dit gaat over het verkeerde",
  "decision.why.wrong_value": "Goed idee, verkeerde details",
  "decision.why.too_risky": "Te veel in één keer",
  "decision.title.cleanup": {
    "one": "{count} bericht van {sender} archiveren",
    "other": "{count} berichten van {sender} archiveren"
  },
  "decision.preview.cleanup": "{total} berichten van {sender} archiveren",
  "decision.title.unsubscribe": "Afmelden bij {sender}",
  "decision.title.mark_read": {
    "one": "{count} bericht van {sender} als gelezen markeren",
    "other": "{count} berichten van {sender} als gelezen markeren"
  },
  "decision.undo.archive": "Ongedaan maken zet elk bericht terug in de map waar het stond.",
  "decision.undo.mark_read": "Ongedaan maken markeert ze weer als ongelezen.",
  "decision.preview.archive": {
    "one": "{count} bericht zou naar het archief gaan",
    "other": "{count} berichten zouden naar het archief gaan"
  },
  "decision.error.conflict": "Iemand heeft dit al beantwoord.",
  "decision.error.title": "De wachtrij kon niet geladen worden",
  "triage.start": "Eén voor één beoordelen",
  "triage.backToList": "Terug naar de lijst",
  "triage.progress": "{done} van {total} beantwoord",
  "triage.done.title": "Wachtrij beoordeeld.",
  "triage.hint.swipe": "Veeg naar rechts om goed te keuren, naar links voor niet nu.",
  "triage.hint.deliberate": "Deze vraagt aandacht: gebruik de knoppen.",
  "triage.hint.keys": "Toetsen: a goedkeuren · n niet nu · r nee, omdat · z ongedaan maken",
  "triage.hint.keysDeliberate": "Toetsen: n niet nu · r nee, omdat — goedkeuren kan alleen met de knop.",
  "triage.toast.approved": "Goedgekeurd — wordt zo verstuurd.",
  "triage.toast.deferred": "Uitgesteld — wordt zo verstuurd.",
  "triage.toast.undo": "Ongedaan maken",
  "rule.template.school.name": "Schoolmail",
  "rule.template.school.description": "Mail van de school van je kinderen wordt als belangrijk gemarkeerd en wordt nooit opgeruimd of afgemeld. Schoolmail lijkt voor elk automatisch signaal op bulkmail, en het bericht dat telt is dat over het uitje van donderdag.",
  "rule.template.family.name": "Gezin en gezondheid",
  "rule.template.family.description": "Mail over je gezin, je kinderen en je gezondheid wordt als belangrijk gemarkeerd en beschermd tegen opruimen.",
  "rule.template.money.name": "Rekeningen en deadlines",
  "rule.template.money.description": "Alles wat betaald moet worden blijft in je inbox en wordt als belangrijk gemarkeerd. Er wordt niets weggezet: een rekening die je niet ziet, betaal je niet.",
  "rule.preview.matched": {
    "zero": "Dit zou niets gevonden hebben",
    "one": "Dit zou {count} bericht gevonden hebben in de laatste {days} dagen",
    "other": "Dit zou {count} berichten gevonden hebben in de laatste {days} dagen"
  },
  "rule.warning.catches_answered_mail": {
    "one": "Het zou {count} bericht opbergen waarop je hebt geantwoord",
    "other": "Het zou {count} berichten opbergen waarop je hebt geantwoord"
  },
  "rule.warning.catches_almost_everything": "Dit raakt bijna al je mail. Meestal komt dat door een voorwaarde die iets uit elke voettekst herkent.",
  "rule.warning.catches_nothing": "Dit vond niets. Controleer het adres of domein voordat je het aanzet.",
  "rule.warning.moves_mail": "Dit haalt mail uit je inbox.",
  "rule.warning.small_sample": "Er is nog weinig geschiedenis, dus deze voorvertoning zegt niet veel.",
  "rule.enabled": "Aan",
  "rule.disabled": "Uit",
  "rule.dormant": "Heeft nog nooit iets gevonden",
  "rule.explain.title": "Waarom staat dit bericht hier?",
  "menu.about": "Over Email Butler",
  "menu.settings": "Instellingen",
  "menu.signOut": "Uitloggen",
  "menu.openNavigation": "Navigatie openen",
  "menu.closeNavigation": "Navigatie sluiten",
  "menu.quit": "Afsluiten",
  "menu.go": "Ga naar",
  "menu.commandPalette": "Opdrachtenpalet",
  "menu.mailbox": "Mailbox",
  "menu.syncNow": "Nu synchroniseren",
  "menu.help": "Help",
  "menu.documentation": "Documentatie",
  "menu.revealLogs": "Logboeken tonen",
  "menu.checkForUpdates": "Controleren op updates",
  "update.available": "Versie {version} staat klaar. Die wordt geïnstalleerd zodra je Email Butler opnieuw opent.",
  "update.notes": "Wat er veranderd is",
  "native.signedOutTitle": "Je bent uitgelogd",
  "native.signedOutBody": "Deze computer heeft geen veilige plek voor je sessie, dus je moet elke keer opnieuw inloggen.",
  "native.deepLinkRefused": "Die link kon niet geopend worden.",
  "notify.critical_message.title": "Er is iets voor je",
  "notify.critical_message.body": "Er kwam een bericht binnen dat Butler niet kon afhandelen.",
  "notify.deadline_near.title": "Een deadline komt eraan",
  "notify.deadline_near.body": "Er moet binnen twee dagen iets gebeuren.",
  "notify.payment_failed.title": "Een betaling is mislukt",
  "notify.payment_failed.body": "Een van je betalingen is niet gelukt.",
  "notify.mailbox_broken.title": "Een mailbox heeft je nodig",
  "notify.mailbox_broken.body": "Butler kan een van je mailboxen niet bereiken.",
  "notify.run_finished.title": "Butler is klaar",
  "notify.run_finished.body": "De taak die je startte is afgerond.",
  "notify.quietHours": "Butler blijft stil tussen {from}:00 en {to}:00 uur.",
  "shortcut.reserved": "Je systeem gebruikt die sneltoets al.",
  "shortcut.needsModifier": "Een globale sneltoets heeft een modificatietoets nodig.",
  "mobile.noScreenLock": "Deze telefoon heeft geen schermvergrendeling, dus iedereen die hem vasthoudt kan je mail lezen. Stel er een in bij je telefooninstellingen.",
  "mobile.noHardwareKeystore": "Deze telefoon bewaart je sessie in software in plaats van in beveiligde hardware. Je schermvergrendeling beschermt hem nog steeds.",
  "mobile.offlineNotice": "Je bent offline. Dit zijn de laatste {days} dagen mail; de rest laadt zodra je verbinding hebt.",
  "mobile.lockedTitle": "Vergrendeld",
  "mobile.lockedBody": "Ontgrendel om je mail te zien.",
  "mobile.undo": "Ongedaan maken",
  "mobile.swipeArchived": "Gearchiveerd",
  "mobile.swipeSnoozed": "Uitgesteld",
  "mobile.unlock": "Ontgrendelen",
  "push.decisionWaiting": "{count, plural, one {# beslissing wacht} other {# beslissingen wachten}}",
  "push.rescueComplete": "Het opruimen van je mailbox is klaar",
  "push.snapshotFailed": "Een momentopname van de Safety Vault is niet voltooid",
  "push.syncBroken": "Een mailbox synchroniseert niet meer",
  "push.deadlineToday": "{count, plural, one {# deadline verloopt vandaag} other {# deadlines verlopen vandaag}}",
  "autonomy.title": "Wat Butler zelf mag doen",
  "autonomy.intro": "Butler vraagt het je voordat het iets doet waar je geen ja op hebt gezegd. Dat pas je hier aan, per soort hulp.",
  "autonomy.pause.title": "Alles stoppen",
  "autonomy.pause.body": "Butler blijft lezen en voorstellen doen, en verandert een week lang niets.",
  "autonomy.pause.active": "Butler staat op pauze. Het leest en stelt voor, en verandert niets.",
  "autonomy.pause.stop": "Butler pauzeren",
  "autonomy.pause.resume": "Butler laten doorgaan",
  "autonomy.levels.title": "De vier niveaus",
  "autonomy.level.0.title": "Meekijken",
  "autonomy.level.0.body": "Butler leest en stelt voor. Er verandert niets in je mailbox zonder jouw ja.",
  "autonomy.level.1.title": "Ordenen",
  "autonomy.level.1.body": "Opbergen, labelen, als gelezen markeren, archiveren. Alles is terug te draaien.",
  "autonomy.level.2.title": "Beheren",
  "autonomy.level.2.body": "Afmelden en opruimen. Een afmelding kun je niet terugdraaien.",
  "autonomy.level.3.title": "Naar buiten treden",
  "autonomy.level.3.body": "Mail versturen namens jou. Iemand anders leest het, en geen enkele undo bereikt die persoon.",
  "autonomy.capabilities.title": "Soorten hulp",
  "autonomy.capability.organise": "Opbergen en labelen",
  "autonomy.capability.archive": "Archiveren",
  "autonomy.capability.mark_read": "Als gelezen markeren",
  "autonomy.capability.draft": "Antwoorden voorbereiden",
  "autonomy.capability.unsubscribe": "Afmelden",
  "autonomy.capability.cleanup": "Oude mail opruimen",
  "autonomy.capability.remind": "Herinneringen",
  "autonomy.capability.send": "Mail versturen",
  "autonomy.capability.delete": "Definitief verwijderen",
  "autonomy.capability.needs": "Vereist niveau {level} of hoger",
  "autonomy.refusals.title": "Wat Butler heeft laten liggen",
  "autonomy.refusals.none": "Butler heeft deze week niets laten liggen.",
  "autonomy.refusal.permission": "{count, plural, one {# keer, omdat jij die actie niet mag uitvoeren} other {# keer, omdat jij die actie niet mag uitvoeren}}",
  "autonomy.refusal.paused": "{count, plural, one {# keer, omdat Butler op pauze staat} other {# keer, omdat Butler op pauze staat}}",
  "autonomy.refusal.never_touch": "{count, plural, one {# keer, omdat je Butler hebt gevraagd die afzender nooit aan te raken} other {# keer, omdat je Butler hebt gevraagd die afzenders nooit aan te raken}}",
  "autonomy.refusal.feature_flag": "{count, plural, one {# keer, omdat die functie uitstaat} other {# keer, omdat die functie uitstaat}}",
  "autonomy.refusal.trust_level": "{count, plural, one {# keer, omdat je daar nog geen ja op hebt gezegd} other {# keer, omdat je daar nog geen ja op hebt gezegd}}",
  "autonomy.refusal.confidence": "{count, plural, one {# keer, omdat Butler het niet zeker genoeg wist} other {# keer, omdat Butler het niet zeker genoeg wist}}",
  "autonomy.refusal.no_snapshot": "{count, plural, one {# keer, omdat er geen geverifieerde back-up is om op terug te vallen} other {# keer, omdat er geen geverifieerde back-up is om op terug te vallen}}",
  "autonomy.error.title": "Je instellingen konden niet worden geladen",
  "autonomy.error.body": "Er is niets veranderd. Probeer het zo nog een keer.",
  "nav.autonomy": "Butler-instellingen",
  "health.authRequired": "Deze mailbox moet opnieuw worden verbonden. Er komt geen mail binnen.",
  "health.syncStalled": "Al {hours} uur geen nieuwe mail gezien.",
  "health.noSnapshot": "Er is nog geen geverifieerde back-up van deze mailbox.",
  "health.snapshotStale": "De laatste geverifieerde back-up is {days} dagen oud.",
  "health.quotaNear": "Deze mailbox is voor {percent}% vol. Als hij vol is, komt er geen mail meer binnen.",
  "health.unsubscribeFailing": "{count, plural, one {# afmelding is niet gelukt} other {# afmeldingen zijn niet gelukt}}",
  "health.backlogGrowing": "{count, plural, one {# bericht van ouder dan een week is nog ongelezen} other {# berichten van ouder dan een week zijn nog ongelezen}}",
  "digest.problems": "{count, plural, one {# ding moet worden opgelost} other {# dingen moeten worden opgelost}}",
  "digest.needs_you": "{count, plural, one {# ding heeft jou nodig} other {# dingen hebben jou nodig}}",
  "digest.handled": "{count, plural, one {Butler heeft # ding afgehandeld} other {Butler heeft # dingen afgehandeld}}",
  "digest.money": "{count, plural, one {# betaling om naar te kijken} other {# betalingen om naar te kijken}}",
  "digest.subscriptions": "{count, plural, one {# abonnement is veranderd} other {# abonnementen zijn veranderd}}",
  "digest.backlog": "{count, plural, one {# ouder bericht is nog ongelezen} other {# oudere berichten zijn nog ongelezen}}",
  "digest.more": "en nog {total}",
  "subscription.price_increase": "De prijs is omhooggegaan.",
  "subscription.charge_missed": "Al {days} dagen niets afgeschreven. Mogelijk is het opgezegd.",
  "subscription.renewal_soon": "Wordt over {days} dagen verlengd.",
  "subscription.trial_ending": "De proefperiode eindigt over {days} dagen.",
  "subscription.payment_failed": "De laatste betaling is mislukt.",
  "subscription.dormant": "Al {days} dagen niets afgeschreven.",
  "anomaly.volume_spike": "Veel meer mail dan gebruikelijk vandaag.",
  "anomaly.sender_burst": "Ongewoon veel berichten van één afzender.",
  "anomaly.sync_stalled": "Deze mailbox synchroniseert niet meer.",
  "anomaly.auth_failing": "Deze mailbox kan niet meer inloggen.",
  "anomaly.bulk_deletion": "Er zijn ongewoon veel berichten verwijderd.",
  "anomaly.unsubscribe_failures": "Meerdere afmeldingen zijn niet gelukt.",
  "anomaly.snapshot_stale": "De back-up van deze mailbox is verouderd.",
  "plan.free": "Gratis",
  "plan.personal": "Persoonlijk",
  "plan.family": "Gezin",
  "plan.business": "Zakelijk",
  "plan.selfHosted": "Zelf gehost",
  "meter.mailboxes": "Mailboxen",
  "meter.users": "Mensen",
  "meter.storage_bytes": "Opgeslagen mail",
  "meter.vault_storage_bytes": "Safety Vault",
  "meter.messages_indexed": "Geïndexeerde berichten",
  "meter.ai_tokens": "Denkwerk van Butler",
  "meter.unlimited": "Geen limiet",
  "meter.approaching": "Bijna aan de limiet",
  "meter.atLimit": "Op de limiet",
  "meter.over": "Over de limiet",
  "meter.neverEnforced": "Wordt gemeten, nooit een reden om te stoppen",
  "billing.title": "Abonnement en gebruik",
  "billing.downgradeConflict": "Overstappen naar dit abonnement brengt je over de limiet van {meter}.",
  "preflight.os.ok": "Besturingssysteem: Ubuntu {version}",
  "preflight.os.untested": "{os} is niet getest. De stack draait in containers en werkt waarschijnlijk, maar wij testen op Ubuntu LTS.",
  "preflight.os.version": "Ubuntu {version} is niet getest. Ondersteund: {supported}.",
  "preflight.architecture.ok": "Architectuur: {architecture}",
  "preflight.architecture.unsupported": "Er zijn geen images voor {architecture}.",
  "preflight.memory.ok": "Geheugen: {found} MB",
  "preflight.memory.tight": "Geheugen: {found} MB. {recommended} MB wordt aanbevolen.",
  "preflight.memory.tooSmall": "Geheugen: {found} MB. {needed} MB is het minimum.",
  "preflight.disk.ok": "Vrije schijfruimte: {found} GB",
  "preflight.disk.tight": "Vrije schijfruimte: {found} GB. De Safety Vault bewaart een volledige kopie van elke mailbox, dus {recommended} GB wordt aanbevolen.",
  "preflight.disk.tooSmall": "Vrije schijfruimte: {found} GB. {needed} GB is het minimum.",
  "preflight.cpu.ok": "CPU-kernen: {found}",
  "preflight.cpu.tooFew": "CPU-kernen: {found}. {needed} is het minimum.",
  "preflight.docker.ok": "Docker {version}",
  "preflight.docker.missing": "Docker is niet geïnstalleerd.",
  "preflight.docker.tooOld": "Docker {version} is te oud. Versie {needed} of nieuwer is nodig.",
  "preflight.compose.ok": "Docker Compose {version}",
  "preflight.compose.missing": "De Docker Compose-plug-in is niet beschikbaar.",
  "preflight.ports.ok": "Poorten 80 en 443 zijn vrij",
  "preflight.ports.taken": "Er luistert al iets op {ports}.",
  "preflight.dns.ok": "Het domein wijst naar deze machine",
  "preflight.dns.unknown": "Kon niet controleren of het domein hierheen wijst. Certificaten mislukken als dat niet zo is.",
  "preflight.dns.mismatch": "Het domein lijkt niet naar deze machine te wijzen. Achter NAT is dat normaal, anders fataal.",
  "preflight.clock.ok": "De klok loopt gelijk",
  "preflight.clock.skewed": "De klok loopt {seconds} seconden uit. Certificaten, inloggen en tweestapscodes gaan allemaal mislukken.",
  "preflight.overcommit.ok": "De geheugeninstellingen van de kernel zijn in orde",
  "preflight.overcommit.strict": "vm.overcommit_memory staat streng. Redis en PostgreSQL kunnen dan falen op een manier die op een applicatiefout lijkt.",
  "health.allOk": "Alles is in orde.",
  "health.migrations.ok": "Het databaseschema is actueel",
  "health.migrations.pending": "{count} migratie(s) zijn niet toegepast",
  "health.migrations.remedy": "Draai ./upgrade.sh, of: docker compose run --rm migrate",
  "health.disk.ok": "Het schijfgebruik is in orde",
  "health.disk.filling": "De schijf is voor {percent}% vol",
  "health.disk.full": "De schijf is voor {percent}% vol. PostgreSQL stopt met schrijven en momentopnamen stoppen.",
  "health.disk.remedy": "Maak nu ruimte vrij. Kijk naar de back-upmap en draai: docker system prune",
  "health.tls.ok": "Het certificaat is nog {days} dagen geldig",
  "health.tls.unknown": "TLS wordt elders afgehandeld",
  "health.tls.expiring": "Het certificaat verloopt over {days} dagen en is niet vernieuwd",
  "health.tls.expired": "Het certificaat is verlopen",
  "health.tls.remedy": "Controleer of poort 80 bereikbaar is: de vernieuwing beantwoordt daar zijn challenge.",
  "health.backups.ok": "Er is een recente geverifieerde back-up",
  "health.backups.old": "De nieuwste back-up is {days} dagen oud",
  "health.backups.stale": "De nieuwste back-up is {days} dagen oud",
  "health.backups.none": "Er is nog nooit een back-up gemaakt. Butler kan niets terugzetten.",
  "health.backups.remedy": "Draai ./backup.sh en zet het daarna in cron.",
  "onboarding.position": "Stap {position} van {total}",
  "onboarding.skip": "Sla dit over",
  "onboarding.goToMail": "Breng me naar mijn mail",
  "onboarding.longWait": "Dit duurt even. Je mag dit sluiten; we gaan zonder jou verder.",
  "onboarding.done.title": "Helemaal klaar",
  "onboarding.done.body": "Butler is aan het werk. Vandaag laat je zien wat jou nodig heeft.",
  "onboarding.error.title": "Er ging iets mis",
  "onboarding.error.body": "Er is niets verloren gegaan. Probeer het zo nog een keer.",
  "onboarding.progress.counting": "We tellen wat er in je mailbox zit.",
  "onboarding.progress.starting": "{done} van {total} tot nu toe.",
  "onboarding.progress.working": "{done} van {total}, nog ongeveer {minutes} minuten.",
  "onboarding.purpose.createTenant": "Een plek voor alles wat Butler leert.",
  "onboarding.purpose.privacy": "Of je mail deze machine mag verlaten.",
  "onboarding.purpose.connectMailbox": "De mailbox waar Butler voor zorgt.",
  "onboarding.purpose.permissions": "Wat je de provider hebt toegestaan te delen.",
  "onboarding.purpose.inventory": "Uitzoeken wat er is.",
  "onboarding.purpose.vaultSnapshot": "Een kopie die Butler kan terugzetten.",
  "onboarding.purpose.firstFindings": "De eerste dingen die je aandacht verdienen.",
  "onboarding.purpose.rescue": "De achterstand doorwerken.",
  "onboarding.purpose.decisions": "Hoe Butler het vraagt als het twijfelt.",
  "onboarding.purpose.today": "Het scherm dat je echt gaat gebruiken.",
  "onboarding.step.create_tenant.title": "Geef je werkruimte een naam",
  "onboarding.step.create_tenant.body": "Alles wat Butler leert, staat hier. Je kunt de naam later aanpassen.",
  "onboarding.step.create_tenant.action": "Werkruimte maken",
  "onboarding.step.privacy_preference.title": "Waar mag Butler nadenken?",
  "onboarding.step.privacy_preference.body": "Butler kan volledig op je eigen machine draaien, of een groter model elders gebruiken voor lastigere vragen. Lokaal is de standaard en je kunt het altijd wijzigen.",
  "onboarding.step.privacy_preference.action": "Houd het lokaal",
  "onboarding.step.connect_mailbox.title": "Verbind een mailbox",
  "onboarding.step.connect_mailbox.body": "Butler leest je mail om die te ordenen. Er wordt nooit iets verstuurd zonder dat je het eerst goedkeurt.",
  "onboarding.step.connect_mailbox.action": "Verbinden",
  "onboarding.step.explain_permissions.title": "Wat je zojuist hebt toegestaan",
  "onboarding.step.explain_permissions.body": "Butler mag je mail lezen, tussen mappen verplaatsen en als gelezen markeren. Versturen mag niet, en definitief verwijderen ook niet.",
  "onboarding.step.explain_permissions.action": "Duidelijk",
  "onboarding.step.inventory.title": "Je mailbox doornemen",
  "onboarding.step.inventory.body": "We tellen wat er is. Bij een grote mailbox duurt dit even, en je mag deze pagina verlaten.",
  "onboarding.step.inventory.action": "Verder",
  "onboarding.step.vault_snapshot.title": "Eerst een kopie maken",
  "onboarding.step.vault_snapshot.body": "Voordat Butler iets opruimt, maakt het een kopie die het kan terugzetten. Er wordt niets aangeraakt tot dit klaar is.",
  "onboarding.step.vault_snapshot.action": "Verder",
  "onboarding.step.first_findings.title": "Wat Butler heeft gevonden",
  "onboarding.step.first_findings.body": "De eerste dingen die je aandacht verdienen. Er is nog niets veranderd.",
  "onboarding.step.first_findings.action": "Laat maar zien",
  "onboarding.step.rescue_start.title": "Ruim de achterstand op",
  "onboarding.step.rescue_start.body": "Butler werkt jaren aan oude mail door en vraagt het je voordat er iets gebeurt dat niet terug te draaien is.",
  "onboarding.step.rescue_start.action": "Starten",
  "onboarding.step.decision_tutorial.title": "Hoe Butler het vraagt",
  "onboarding.step.decision_tutorial.body": "Als Butler twijfelt, vraagt het het je. Elke vraag vertelt wat het zou doen en om hoeveel berichten het gaat.",
  "onboarding.step.decision_tutorial.action": "Begrepen",
  "onboarding.step.today.title": "Je bent klaar",
  "onboarding.step.today.body": "Vandaag laat zien wat jou nodig heeft. Stilte betekent dat Butler het heeft afgehandeld.",
  "onboarding.step.today.action": "Naar Vandaag",
  "onboarding.waiting.title": "Butler is nog bezig",
  "onboarding.waiting.body": "Deze stap loopt op de achtergrond door. Je kunt deze pagina verlaten en later terugkomen; zodra alles klaar is gaat de wizard automatisch verder.",
  "rescue.title": "Rescue",
  "rescue.intro": "Analyseer de achterstand veilig voordat je bepaalt wat wordt georganiseerd. Deze release leest alleen geïndexeerde metadata en wijzigt nooit mail bij de provider.",
  "rescue.noMailbox": "Verbind een mailbox voordat je Rescue start.",
  "rescue.mailbox": "Mailbox",
  "rescue.waitForSnapshot": "Rescue komt beschikbaar zodra de eerste Safety Vault-snapshot is geverifieerd.",
  "rescue.startAnalysis": "Veilige analyse starten",
  "rescue.startUpdatedAnalysis": "Analyseer {count} geïndexeerde berichten",
  "rescue.newMessagesIndexed": "Sinds deze analyse is nieuwe mail geïndexeerd. Start Rescue opnieuw om alle {count} geïndexeerde berichten mee te nemen.",
  "rescue.pause": "Pauzeren",
  "rescue.resume": "Hervatten",
  "rescue.cancel": "Annuleren",
  "rescue.status.title": "Analysestatus",
  "rescue.status.planning": "Planning",
  "rescue.status.awaiting_backup": "Wacht op Safety Vault",
  "rescue.status.ready": "Klaar",
  "rescue.status.running": "Analyseren",
  "rescue.status.paused": "Gepauzeerd",
  "rescue.status.completed": "Voltooid",
  "rescue.status.failed": "Aandacht nodig",
  "rescue.status.cancelled": "Geannuleerd",
  "rescue.progress": "{processed} van {total} berichten geanalyseerd",
  "rescue.findings": "Bevindingen",
  "rescue.findings.empty": "Nog geen bevindingen. Resultaten verschijnen tijdens de analyse.",
  "rescue.finding.bulk_sender": "Afzender",
  "rescue.finding.unpaid_obligation": "Onbetaalde verplichting",
  "rescue.finding.stale_thread": "Oude onbeantwoorde mail",
  "rescue.finding.unanswered_question": "Onbeantwoorde vraag",
  "rescue.finding.large_attachment": "Grote bijlagen",
  "rescue.finding.security_event": "Beveiligingssignaal",
  "rescue.finding.duplicate_group": "Duplicaten",
  "rescue.finding.old_unread": "Oude ongelezen mail",
  "rescue.finding.subscription": "Abonnement",
  "rescue.finding.count": "{count} berichten",
  "a11y.skipToContent": "Naar de inhoud",
  "network.offline": "Je bent offline. Wat je ziet is van een moment geleden.",
  "network.offlineStale": "Je bent offline en dit scherm kan verouderd zijn.",
  "network.reconnecting": "Opnieuw verbinden.",
  "network.degraded": "De verbinding is traag. Sommige dingen duren langer.",
  "error.offline.title": "Geen verbinding",
  "error.offline.body": "We pakken de draad weer op zodra je online bent.",
  "error.rateLimited.title": "Te snel",
  "error.rateLimited.body": "Geef het even, dan gaat het vanzelf verder.",
  "error.signedOut.title": "Je bent uitgelogd",
  "error.signedOut.body": "Log opnieuw in om verder te gaan. Er is niets verloren gegaan.",
  "error.notAllowed.title": "Niet toegestaan",
  "error.notAllowed.body": "Jouw rol omvat dit niet. Een beheerder kan dat aanpassen.",
  "error.gone.title": "Dat is er niet meer",
  "error.gone.body": "Het is mogelijk verplaatst of verwijderd. Herlaad om te zien hoe het nu staat.",
  "error.invalid.title": "Er klopt iets niet",
  "error.invalid.body": "Controleer het gemarkeerde veld en probeer het opnieuw.",
  "error.changed.title": "Iemand heeft dit gewijzigd",
  "error.changed.body": "Herlaad voordat je opslaat, zodat je hun wijziging niet overschrijft.",
  "error.mailboxDown.title": "De mailprovider reageert niet",
  "error.mailboxDown.body": "We blijven het proberen. Er is niets verloren gegaan.",
  "error.noBackup.title": "Butler doet dat niet zonder back-up",
  "error.noBackup.body": "Er is geen geverifieerde kopie om iets mee terug te zetten, dus er is niets gewijzigd.",
  "error.ours.title": "Dat ligt aan ons",
  "error.ours.body": "Er ging iets mis aan onze kant. Het is vastgelegd.",
  "empty.unknown.title": "We konden het niet controleren",
  "empty.unknown.body": "Dat is niet hetzelfde als dat er niets is. Probeer het opnieuw.",
  "empty.noMatch.title": "Niets komt overeen",
  "empty.noMatch.body": "Je mail is er nog; het filter verbergt het.",
  "empty.noMatch.action": "Filter wissen",
  "batch.success": "{count, plural, one {# bericht gedaan} other {# berichten gedaan}}",
  "batch.partial": "{failed, plural, one {# is niet gelukt} other {# zijn niet gelukt}}, {succeeded} wel.",
  "batch.failure": "{count, plural, one {# bericht is niet gelukt} other {# berichten zijn niet gelukt}}",
  "shortcut.search": "Zoeken",
  "shortcut.today": "Vandaag",
  "shortcut.decisions": "Beslissingen",
  "shortcut.next": "Volgende",
  "shortcut.previous": "Vorige",
  "shortcut.open": "Openen",
  "shortcut.archive": "Archiveren",
  "shortcut.markRead": "Als gelezen markeren",
  "shortcut.snooze": "Uitstellen",
  "shortcut.reply": "Beantwoorden",
  "shortcut.undo": "Ongedaan maken",
  "shortcut.selectAll": "Alles selecteren",
  "shortcut.escape": "Sluiten",
  "shortcut.help": "Sneltoetsen",
  "mail.footer.ignore": "Verwachtte je dit bericht niet, dan kun je het negeren. Niemand kan er iets mee zonder de link hierboven.",
  "mail.mailbox_needs_attention.action": "Mailbox opnieuw verbinden",
  "mail.mailbox_needs_attention.body": "Een van je mailboxen kan niet meer inloggen, dus er komt geen nieuwe mail binnen. Opnieuw verbinden kost een moment.",
  "mail.mailbox_needs_attention.heading": "Een mailbox synchroniseert niet meer",
  "mail.mailbox_needs_attention.subject": "Een mailbox moet opnieuw worden verbonden",
  "mail.reset_password.action": "Kies een nieuw wachtwoord",
  "mail.reset_password.body": "Iemand heeft gevraagd het wachtwoord van dit {platform}-account opnieuw in te stellen. De link werkt {hours} uur. Was jij dat niet, dan is er niets veranderd.",
  "mail.reset_password.heading": "Stel je wachtwoord opnieuw in",
  "mail.reset_password.subject": "Stel je wachtwoord opnieuw in",
  "mail.verify_email.action": "Adres bevestigen",
  "mail.verify_email.body": "Klik hieronder om dit adres te bevestigen en je {platform}-account af te ronden. De link werkt {hours} uur.",
  "mail.verify_email.heading": "Bevestig je e-mailadres",
  "mail.verify_email.subject": "Bevestig je e-mailadres",
  "mail.workspace_invitation.action": "Uitnodiging accepteren",
  "mail.workspace_invitation.body": "Je bent uitgenodigd voor een werkruimte op {platform}.",
  "mail.workspace_invitation.heading": "Je bent uitgenodigd",
  "mail.workspace_invitation.subject": "Je bent uitgenodigd voor een werkruimte",
  "mailbox.status.active": "Actief",
  "mailbox.status.auth_pending": "Wacht op aanmelden",
  "mailbox.status.backing_up": "Back-up bezig",
  "mailbox.status.backup_pending": "Back-up in wachtrij",
  "mailbox.status.connected": "Verbonden",
  "mailbox.status.created": "Niet verbonden",
  "mailbox.status.degraded": "Heeft problemen",
  "mailbox.status.disconnected": "Verbinding verbroken",
  "mailbox.status.inventory": "Berichten tellen",
  "mailbox.status.paused": "Gepauzeerd",
  "mailbox.status.reauth_required": "Meld je opnieuw aan",
  "mailbox.status.rescuing": "Opruiming bezig",
  "mailbox.status.snapshot_verified": "Back-up gecontroleerd",
  "mailboxes.add": "Mailbox verbinden",
  "mailboxes.connect": "Verbinden",
  "mailboxes.connected": "Verbonden mailboxen",
  "mailboxes.disconnect": "Verbinding verbreken",
  "mailboxes.edit": "Bewerken",
  "mailboxes.empty.body": "Verbind je eerste mailbox om te beginnen. Je wachtwoord wordt versleuteld opgeslagen en nooit meer getoond.",
  "mailboxes.empty.title": "Nog geen mailbox",
  "mailboxes.error.body": "Het verzoek is niet doorgekomen. Er is niets gewijzigd.",
  "mailboxes.error.title": "Er ging iets mis",
  "mailboxes.field.displayName": "Naam voor deze mailbox",
  "mailboxes.field.email": "E-mailadres",
  "mailboxes.field.imapHost": "IMAP-server",
  "mailboxes.field.imapPort": "IMAP-poort",
  "mailboxes.field.password": "Wachtwoord",
  "mailboxes.field.passwordHelp": "Laat het wachtwoord leeg om het huidige te behouden. Bij opslaan wordt de nieuwe verbinding altijd eerst getest.",
  "mailboxes.field.security": "Versleuteling",
  "mailboxes.field.smtpHost": "SMTP-server (leeg laten om dit af te leiden)",
  "mailboxes.field.username": "Gebruikersnaam (leeg laten om het e-mailadres te gebruiken)",
  "mailboxes.form.title": "Mailbox verbinden",
  "mailboxes.form.editTitle": "Mailbox bewerken",
  "mailboxes.intro": "Email Butler leest je e-mail hiervandaan. Er verandert niets in je mailbox tot jij dat zegt.",
  "mailboxes.next.inventory": "Verbonden. We tellen nu je berichten.",
  "mailboxes.next.ready": "Verbonden en klaar.",
  "mailboxes.next.snapshot": "Verbonden. Er wordt eerst een back-up gemaakt voordat er iets wordt aangeraakt.",
  "mailboxes.openRescue": "Rescue openen",
  "mailboxes.security.starttls": "STARTTLS",
  "mailboxes.security.tls": "TLS",
  "mailboxes.remove": "Verwijderen",
  "mailboxes.remove.confirm": "{address} verwijderen? Synchronisatie stopt direct, maar geïndexeerde mail en Safety Vault-back-ups blijven behouden.",
  "mailboxes.returnToOnboarding": "Doorgaan met onboarding",
  "mailboxes.save": "Opslaan en testen",
  "mailboxes.test": "Verbinding testen",
  "mailboxes.test.authFailed": "Server bereikt, wachtwoord geweigerd",
  "mailboxes.test.hint.auth": "De server antwoordde maar weigerde de gebruikersnaam of het wachtwoord. Gebruikt je provider tweestapsverificatie, dan heb je mogelijk een app-wachtwoord nodig.",
  "mailboxes.test.hint.host": "Controleer de servernaam en de poort. Een firewall tussen hier en de server ziet er ook zo uit.",
  "mailboxes.test.hint.ok": "De server accepteert deze gegevens. Je kunt de mailbox nu verbinden.",
  "mailboxes.test.ok": "Verbinding gelukt",
  "mailboxes.test.unreachable": "Kon die server niet bereiken",
  "mailboxes.title": "Mailboxen",
  "mailboxes.vaultVerified": "Safety Vault gecontroleerd — Rescue is klaar",
  "nav.admin": "Platform",
  "admin.title": "Platform",
  "admin.intro": "Instellingen voor deze installatie. Alles wat hier verandert wordt vastgelegd, met wie het deed en wanneer.",
  "admin.youAre.owner": "Je bent eigenaar van deze installatie.",
  "admin.youAre.admin": "Je bent beheerder. Alleen een eigenaar kan beheerders toevoegen of verwijderen.",
  "admin.youAre.operator": "Je bent operator. Je kunt instellingen zien maar niet wijzigen.",
  "admin.tab.settings": "Instellingen",
  "admin.tab.accounts": "Accounts",
  "admin.tab.providers": "Modellen",
  "admin.tab.admins": "Beheerders",
  "admin.tab.audit": "Activiteit",
  "admin.error.title": "Er ging iets mis",
  "admin.error.body": "Het verzoek is niet doorgekomen. Er is niets gewijzigd.",
  "admin.saved": "Opgeslagen",
  "admin.saved.body": "De wijziging is doorgevoerd en vastgelegd.",
  "admin.settings.title": "Instellingen van deze installatie",
  "admin.accounts.title": "Tenantaccount aanmaken",
  "admin.accounts.intro": "Maakt het eigenaarsaccount en de werkruimte samen aan. De nieuwe eigenaar ontvangt een eenmalige link om zelf een wachtwoord in te stellen en start daarna de onboardingwizard.",
  "admin.accounts.mailRequired.title": "Uitgaande e-mail is vereist",
  "admin.accounts.mailRequired.body": "Stel platform-SMTP in, zet het aan en test het onder Instellingen voordat je een account aanmaakt. De wachtwoordlink mag nooit aan een beheerder worden getoond.",
  "admin.accounts.adminOnly": "Alleen een platformeigenaar of -beheerder mag accounts aanmaken.",
  "admin.accounts.email": "E-mailadres eigenaar",
  "admin.accounts.displayName": "Naam eigenaar",
  "admin.accounts.workspaceName": "Naam werkruimte",
  "admin.accounts.workspaceSlug": "Werkruimteadres",
  "admin.accounts.workspaceSlugHint": "Kleine letters, cijfers en koppeltekens; bijvoorbeeld rotz-media.",
  "admin.accounts.create": "Account maken en instellink versturen",
  "admin.field.platformName": "Naam van deze installatie",
  "admin.field.supportEmail": "Supportadres",
  "admin.field.openRegistration": "Iedereen mag een account aanmaken",
  "admin.smtp.title": "Uitgaande e-mail",
  "admin.smtp.intro": "Gebruikt voor de berichten van het platform zelf: adresbevestigingen, wachtwoordherstel en uitnodigingen. Niet om iemands eigen e-mail te versturen.",
  "admin.mail.ready": "Platformmail is ingesteld en staat aan.",
  "admin.mail.disabled": "Platformmail is ingesteld maar staat uit. Niemand ontvangt een wachtwoordherstel.",
  "admin.mail.unconfigured": "Platformmail is niet ingesteld. Adresbevestigingen en wachtwoordherstel kunnen niet worden verstuurd.",
  "admin.field.smtpEnabled": "Platformmail versturen",
  "admin.field.smtpHost": "SMTP-server",
  "admin.field.smtpPort": "SMTP-poort",
  "admin.field.smtpSecurity": "Versleuteling",
  "admin.smtp.none": "Geen",
  "admin.field.smtpUsername": "Gebruikersnaam",
  "admin.field.smtpPassword": "Wachtwoord",
  "admin.field.fromAddress": "Afzenderadres",
  "admin.field.fromName": "Afzendernaam",
  "admin.secret.stored": "Er is een wachtwoord opgeslagen. Laat dit leeg om het te behouden.",
  "admin.secret.absent": "Er is geen wachtwoord opgeslagen.",
  "admin.smtp.test": "Testverbinding maken",
  "admin.smtp.ok": "De mailserver accepteert deze gegevens",
  "admin.smtp.failed": "De mailserver weigerde",
  "admin.smtp.noDetail": "De server gaf geen reden.",
  "admin.smtp.clearPassword": "Opgeslagen wachtwoord verwijderen",
  "admin.providers.title": "Modelaanbieders",
  "admin.providers.intro": "Voor het hele platform geregistreerd. Elke werkruimte bepaalt nog steeds zelf of haar e-mail een cloudaanbieder mag bereiken.",
  "admin.providers.empty": "Nog geen aanbieders. Er wordt niets geclassificeerd of opgesteld tot er één is toegevoegd.",
  "admin.provider.add": "Aanbieder toevoegen",
  "admin.provider.register": "Registreren",
  "admin.provider.enable": "Aanzetten",
  "admin.provider.disable": "Uitzetten",
  "admin.provider.healthy": "Werkt",
  "admin.provider.unhealthy": "Antwoordt niet",
  "admin.provider.off": "Uit",
  "admin.locality.local": "Op je eigen hardware",
  "admin.locality.cloud": "In de cloud",
  "admin.field.slug": "Korte naam",
  "admin.field.kind": "Soort",
  "admin.field.locality": "Waar het draait",
  "admin.field.baseUrl": "Adres",
  "admin.field.apiKey": "API-sleutel",
  "admin.field.apiKeyHint": "Versleuteld opgeslagen en nooit meer getoond. Laat leeg voor een aanbieder die er geen nodig heeft.",
  "admin.field.capabilities": "Mogelijkheden",
  "admin.field.capabilitiesHint": "Gescheiden door komma's, bijvoorbeeld: chat, embedding",
  "admin.field.priority": "Prioriteit (lager wordt eerst geprobeerd)",
  "admin.kind.ollama": "Ollama",
  "admin.kind.vllm": "vLLM",
  "admin.kind.openai": "OpenAI",
  "admin.kind.openai_compatible": "OpenAI-compatibel",
  "admin.kind.anthropic": "Anthropic",
  "admin.kind.gemini": "Gemini",
  "admin.kind.azure_openai": "Azure OpenAI",
  "admin.admins.title": "Wie deze installatie beheert",
  "admin.admins.intro": "Een beheerder kan elke instelling hier wijzigen. Alleen een eigenaar kan beheerders toevoegen of verwijderen; dat voorkomt dat één gestolen sessie blijvend wordt.",
  "admin.admins.grant": "Toekennen",
  "admin.admins.revoke": "Intrekken",
  "admin.admins.ownerOnly": "Alleen een eigenaar kan beheerders toevoegen of verwijderen.",
  "admin.field.grantEmail": "E-mailadres van een bestaand account",
  "admin.field.role": "Rol",
  "admin.role.owner": "Eigenaar",
  "admin.role.admin": "Beheerder",
  "admin.role.operator": "Operator",
  "admin.audit.title": "Activiteit",
  "admin.audit.intro": "Elke platformwijziging, nieuwste eerst. Dit overzicht kan niet worden bewerkt of verwijderd.",
  "firstWorkspace.title": "Nog geen werkruimte",
  "firstWorkspace.body": "In een werkruimte staan je mailboxen, regels en geschiedenis. Je kunt er later mensen aan toevoegen.",
  "firstWorkspace.name": "Naam van de werkruimte",
  "firstWorkspace.slug": "Adres",
  "firstWorkspace.slugHint": "Kleine letters, cijfers en koppeltekens. Het staat in links en kan later niet worden gewijzigd.",
  "firstWorkspace.create": "Werkruimte maken",
  "firstWorkspace.signedInAs": "Aangemeld als {email}.",
  "firstWorkspace.taken": "Dat werkruimte-adres is al in gebruik",
  "firstWorkspace.takenBody": "Kies een andere. Er is niets aangemaakt.",
  "firstWorkspace.error": "Er ging iets mis",
  "firstWorkspace.errorBody": "De werkruimte is niet aangemaakt. Er is niets gewijzigd.",
  "mailboxes.connectGmail": "Gmail verbinden",
  "mailboxes.connectMicrosoft": "Outlook verbinden",
  "mailboxes.oauth.connected": "Mailbox verbonden",
  "mailboxes.oauth.connected.body": "Email Butler leest hem nu. Er wordt een back-up gemaakt voordat er iets wordt aangeraakt.",
  "mailboxes.oauth.declined": "Er is niets verbonden",
  "mailboxes.oauth.declined.body": "Je hebt geen toegang gegeven, dus er is niets gewijzigd. Je kunt het altijd opnieuw proberen.",
  "mailboxes.oauth.expired": "Die link was verlopen",
  "mailboxes.oauth.expired.body": "Een verbinding heeft tien minuten om af te ronden. Begin opnieuw; er gaat niets verloren.",
  "mailboxes.oauth.failed": "De verbinding is niet afgerond",
  "mailboxes.oauth.failed.body": "De provider weigerde de uitwisseling. Er is niets opgeslagen. Probeer het opnieuw en meld het bij je beheerder als het blijft gebeuren.",
  "mailboxes.oauth.unconfigured": "Deze provider is nog niet ingesteld",
  "mailboxes.oauth.unconfigured.body": "Een beheerder moet eerst de client-gegevens invullen op het Platform-scherm.",
  "mailboxes.oauth.no_refresh_token": "De provider gaf alleen tijdelijke toegang",
  "mailboxes.oauth.no_refresh_token.body": "Zonder blijvende toestemming zou de mailbox binnen een uur stoppen met synchroniseren, dus er is niets verbonden. Probeer het opnieuw en accepteer alle gevraagde rechten.",
  "mailboxes.oauth.no_address": "De provider gaf niet aan om welke mailbox het ging",
  "mailboxes.oauth.no_address.body": "Er is niets verbonden. Meestal betekent dit dat er is aangemeld met een account zonder mailbox.",
  "wizard.title": "Mailbox toevoegen",
  "wizard.address.help": "Begin met het adres. Butler leidt af wat kan, en vraagt alleen wat niet kan.",
  "wizard.continue": "Doorgaan",
  "wizard.route.gmail": "Dat is een Google-mailbox. De aanbevolen manier om te koppelen loopt via Google, zodat je wachtwoord Butler nooit bereikt.",
  "wizard.route.microsoft": "Dat is een Microsoft-mailbox. De aanbevolen manier om te koppelen loopt via Microsoft, zodat je wachtwoord Butler nooit bereikt.",
  "wizard.imapAnyway": "Toch IMAP gebruiken",
  "wizard.note.appPassword": "Deze provider verwacht een app-wachtwoord",
  "wizard.note.appPassword.body": "Je gewone wachtwoord wordt waarschijnlijk geweigerd. Maak een app-specifiek wachtwoord aan in de beveiligingsinstellingen van je provider en gebruik dat hier.",
  "wizard.note.protonBridge": "Proton heeft zijn Bridge nodig",
  "wizard.note.protonBridge.body": "Proton-mailboxen zijn end-to-end versleuteld en alleen bereikbaar via Proton Bridge op de machine waar Butler draait. De ingevulde host is het lokale adres van de Bridge.",
  "common.back": "Terug",
  "admin.oauth.title": "Gmail en Outlook",
  "admin.oauth.intro": "Eén registratie per installatie, waar elke werkruimte via verbindt. Zonder deze gegevens kunnen mensen nog steeds een mailbox via IMAP verbinden.",
  "admin.oauth.redirect": "Registreer dit adres bij beide providers als redirect-URI: {url}",
  "admin.field.googleClientId": "Google client-ID",
  "admin.field.googleClientSecret": "Google client secret",
  "admin.field.microsoftClientId": "Microsoft client-ID",
  "admin.field.microsoftClientSecret": "Microsoft client secret",
  "admin.field.microsoftTenant": "Microsoft-directory",
  "admin.field.microsoftTenantHint": "common voor elk account, organizations alleen voor werkaccounts, of een directory-ID voor één organisatie.",
  "mail.obligation_reminder.subject": "Vervalt {date}: {organisation}",
  "mail.obligation_reminder.heading": "Er komt een deadline aan",
  "mail.obligation_reminder.body": "{organisation} — {amount} — te voldoen uiterlijk {date}. Dit komt uit je eigen mail; {platform} stopt met herinneren zodra het is afgehandeld.",
  "mail.daily_digest.subject": "Je dagelijkse mailoverzicht",
  "mail.daily_digest.heading": "Wat er in je mail gebeurde",
  "mail.daily_digest.body": "Voor je opgeruimd: {handled} berichten. Deadlines komende week: {deadlines}. Voorstellen die op je wachten: {offers}. Afspraken op komst: {appointments}. Abonnementen die verlengen: {renewals}. Problemen die aandacht vragen: {problems}. Het volledige overzicht staat op je dashboard.",
  "digest.section.handled": "{count} berichten voor je afgehandeld",
  "digest.section.due": "{deadlines} deadlines en {appointments} afspraken op komst",
  "digest.section.offers": "{count} voorstellen wachten op je beslissing",
  "mail.attachment.unnamed": "Naamloze bijlage",
  "mail.compose.title": "Nieuw bericht",
  "mail.compose.from": "Van",
  "mail.compose.to": "Aan",
  "mail.compose.toPlaceholder": "naam@voorbeeld.nl, ander@voorbeeld.nl",
  "mail.compose.cc": "Cc",
  "mail.compose.subject": "Onderwerp",
  "mail.compose.placeholder": "Je bericht, in je eigen woorden…",
  "mail.compose.send": "Versturen",
  "mail.compose.cancel": "Annuleren",
  "mail.compose.sent": "Verstuurd, en opgeborgen in je mailbox.",
  "mail.compose.failed": "Niet verstuurd. Er is niets verzonden — controleer de adressen en probeer opnieuw.",
  "digest.section.problems": "{count} dingen die zich anders gedragen dan normaal",
  "digest.section.renewals": "{count} abonnementen die deze week verlengen",
  "money.title": "Geld",
  "money.empty": "Nog niets. Bonnetjes en verlengingen verschijnen hier zodra je mail is gelezen.",
  "money.error.title": "Kon het geldscherm niet laden",
  "money.trouble.title": "Betalingen die aandacht vragen",
  "money.trouble.failed": "Betaling mislukt — {vendor}",
  "money.trouble.overdue": "Achterstallig — {vendor}",
  "money.trouble.deadline": "handel vóór {date}",
  "money.spend.title": "Maandelijkse uitgaven",
  "money.spend.perMonth": "per maand",
  "money.spend.detail": "{count} abonnementen, {irregular} onregelmatig en buiten het totaal",
  "money.subscriptions.title": "Abonnementen",
  "money.timeline.title": "Wat er van je rekening gaat",
  "money.timeline.empty": "Niets te betalen in de komende 45 dagen.",
  "money.timeline.estimated": "schatting",
  "money.cadence.weekly": "wekelijks",
  "money.cadence.monthly": "maandelijks",
  "money.cadence.quarterly": "per kwartaal",
  "money.cadence.yearly": "jaarlijks",
  "money.cadence.irregular": "onregelmatig",
  "money.status.active": "actief",
  "money.status.lapsed": "verlopen",
  "money.status.cancelled": "opgezegd",
  "money.status.unknown": "onbekend",
  "today.appointment.accept": "Accepteren",
  "today.appointment.tentative": "Misschien",
  "today.appointment.decline": "Afslaan",
  "today.appointment.response.accepted": "Je hebt geaccepteerd",
  "today.appointment.response.declined": "Je hebt afgeslagen",
  "today.appointment.response.tentative": "Je zei misschien",
  "search.title": "Zoeken",
  "search.label": "Zoek een bericht",
  "search.placeholder": "een factuurnummer, een naam, of waar het over ging",
  "search.hint": "Zoekt op de woorden in je mail én op de betekenis, tegelijk.",
  "search.submit": "Zoeken",
  "search.results": "{count} resultaten voor “{query}”",
  "search.noResults": "Niets gevonden voor “{query}”",
  "search.hasAttachments": "heeft bijlagen",
  "search.keywordOnly": "Alleen op woorden gezocht — zoeken op betekenis is nu niet beschikbaar.",
  "search.matched.keyword": "je woorden",
  "search.matched.semantic": "de betekenis",
  "search.matched.both": "allebei",
  "search.error.title": "Zoeken lukte niet",
  "search.error.body": "Er is niets verloren. Probeer het zo nog eens.",
  "activity.title": "Wat Butler deed",
  "activity.subtitle": "Elke actie, nieuwste eerst. Alles wat omkeerbaar is kun je terugzetten.",
  "activity.empty": "Butler heeft nog niets gedaan.",
  "activity.counts": "{count} van {total} berichten",
  "activity.failed": "{count} mislukt",
  "activity.status.undone": "teruggezet",
  "activity.action.archive": "gearchiveerd",
  "activity.action.mark_read": "als gelezen gemarkeerd",
  "activity.action.trash": "naar prullenbak",
  "activity.action.delete": "verwijderd",
  "activity.action.move": "verplaatst",
  "activity.undo.do": "Ongedaan maken",
  "activity.undo.working": "Bezig met terugzetten…",
  "activity.undo.done": "{count} berichten teruggezet.",
  "activity.undo.partial": "{count} berichten teruggezet; {failed} konden niet worden verplaatst.",
  "activity.undo.failed": "Er is niets gewijzigd. Probeer het zo nog eens.",
  "activity.undo.already": "al teruggezet",
  "activity.undo.cannot": "kan niet ongedaan worden gemaakt",
  "activity.error.title": "Kon niet laden wat Butler deed",
  "mail.draft.suggest": "Stel een antwoord voor",
  "mail.draft.working": "Aan het schrijven…",
  "mail.draft.ready": "Er staat een voorstel in het vak. Lees het, pas aan wat je wilt, en verstuur.",
  "mail.draft.readyWithWarnings": "Voorstel klaar — lees goed na: {warnings}.",
  "mail.draft.failed": "Kon geen voorstel schrijven. Je eigen woorden werken nog gewoon.",
  "mail.draft.tone": "Toon",
  "mail.draft.tone.neutral": "Neutraal",
  "mail.draft.tone.friendly": "Vriendelijk",
  "mail.draft.tone.formal": "Formeel",
  "mail.draft.tone.brief": "Kort",
  "mail.draft.tone.warm": "Warm",
  "mail.draft.warning.contains_commitment": "het belooft iets",
  "mail.draft.warning.apologises_unprompted": "het maakt ongevraagd excuses",
  "mail.draft.warning.mentions_assistant": "het noemt dat een assistent het schreef",
  "mail.draft.warning.quotes_the_message": "het citeert het bericht terug",
  "mail.draft.warning.has_placeholder": "er staat nog een invulplek in",
  "mail.draft.warning.empty": "het kwam leeg terug",
  "mail.draft.warning.too_long": "het is erg lang",
  "today.doors.offers": "{count} voorstellen wachten op je antwoord",
  "today.doors.offers.badge": "vraagt je",
  "today.doors.offers.action": "Loop ze door",
  "today.doors.money": "{count} betalingen vragen aandacht",
  "today.doors.money.badge": "geld",
  "today.doors.money.action": "Open geld",
  "today.doors.anomalies": "{count} dingen gedragen zich anders dan normaal",
  "today.doors.anomalies.badge": "ongewoon",
  "today.doors.anomalies.action": "Bekijk wat er gebeurde",
  "butler.title": "Vraag het Butler",
  "butler.subtitle": "Vragen over je eigen mail, alleen beantwoord vanuit je eigen mail.",
  "butler.label": "Wat wil je weten?",
  "butler.placeholder": "wat vroeg de leasemaatschappij me te betalen?",
  "butler.hint": "Elk antwoord noemt de berichten waaruit het komt, zodat je het kunt nakijken.",
  "butler.ask": "Vragen",
  "butler.thinking": "Je mail aan het lezen…",
  "butler.startOver": "Begin een nieuw gesprek",
  "butler.readFrom": "Beantwoord vanuit {cited} van de {retrieved} gelezen berichten.",
  "butler.failed": "Kon dat nu niet beantwoorden. Er is niets gewijzigd.",
  "butler.status.not_found": "Niets in je mail beantwoordt dat, dus Butler gokt niet.",
  "butler.status.refused": "Die vraag is te lang of te kort om te beantwoorden.",
  "butler.status.failed": "Het antwoord kon niet worden gemaakt. Probeer het nog eens.",
  "waiting.title": "Wie wacht er",
  "waiting.subtitle": "Toezeggingen uit je mail — die van hen aan jou, en die van jou aan hen.",
  "waiting.owedToYou": "Zij moeten jou nog",
  "waiting.owedToYou.empty": "Niemand moet je iets dat Butler kan vinden.",
  "waiting.youOwe": "Jij moet hen nog",
  "waiting.youOwe.empty": "Je hebt niets toegezegd dat Butler kan vinden.",
  "waiting.done": "Gedaan",
  "waiting.dismiss": "Geen toezegging",
  "waiting.assumed": "aangenomen datum",
  "waiting.error.title": "Kon niet laden wie er wacht"
}
